module.exports = __webpack_public_path__ + "static/media/calendar.0d58cc4c.svg";